import { Shield, Clock, Heart, FileText } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Differentials = () => {
  const { t } = useLanguage();

  const differentials = [
    {
      icon: Shield,
      title: t('differentials.licensed.title'),
      description: t('differentials.licensed.description')
    },
    {
      icon: Clock,
      title: t('differentials.availability.title'),
      description: t('differentials.availability.description')
    },
    {
      icon: Heart,
      title: t('differentials.bilingual.title'),
      description: t('differentials.bilingual.description')
    },
    {
      icon: FileText,
      title: t('differentials.insurance.title'),
      description: t('differentials.insurance.description')
    }
  ];

  return (
    <section className="py-20 bg-section-bg">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {differentials.map((item, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <item.icon className="h-8 w-8 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-4 leading-tight">
                {item.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentials;